import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceUtils } from '../service-utils/service-utils';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';
import { AddressDetail, AddressSuggestion } from './address-lookup.models';

@Injectable({ providedIn: 'root' })
export class AddressLookupService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    /** The typeahead runs its own inline state, so the app-wide overlay never flashes over a keystroke. */
    private readonly noLoadingHeaders = LoadingHeaders.httpHeadersWithNoLoading();

    autocomplete(tenantId: string, search: string, sessionToken: string, regionCode?: string): Observable<AddressSuggestion[]> {
        let params = new HttpParams().set('search', search).set('sessionToken', sessionToken);
        if (regionCode) {
            params = params.set('regionCode', regionCode);
        }

        return this.http.get<AddressSuggestion[]>(`${this.serviceUtils.getBaseUrl('address-lookup', tenantId)}/autocomplete`, {
            params,
            headers: this.noLoadingHeaders,
        });
    }

    getDetail(tenantId: string, suggestionId: string, sessionToken: string): Observable<AddressDetail> {
        const params = new HttpParams().set('suggestionId', suggestionId).set('sessionToken', sessionToken);

        return this.http.get<AddressDetail>(`${this.serviceUtils.getBaseUrl('address-lookup', tenantId)}/details`, {
            params,
            headers: this.noLoadingHeaders,
        });
    }
}
